import { Button } from '@arcadiapower/shrike';
import { Link } from '~/components/link';
import { Title, Description } from '~/components/typography';
import { WEBSITE_URL } from '~/utils/constants';
import { Wrapper } from '../errors/error.util';

export const CsUnavailable = ({ heading, subHeading }: { heading: string; subHeading: string }) => {
  return (
    <Wrapper testId="screen-Unexpected">
      <Title textAlign="center" marginTop="48px">
        {heading}
      </Title>
      <div style={{ width: '353px', marginLeft: 'auto', marginRight: 'auto' }}>
        <Description textAlign="center" marginTop="24px">
          {subHeading}
        </Description>
      </div>
      <Link color="primary" openInNewTab={false} aria-label="RedirectToWebsite" href={WEBSITE_URL}>
        <Button mode="primary">Explore Website</Button>
      </Link>
    </Wrapper>
  );
};
